
/**
 * @deprecated Use ValidatorErrorTypes enum instead
 */
export const validatorErrorTypes = Object.freeze({
  ApplicationError: 'ApplicationError',
  InstructionError: 'InstructionError'
});

export enum ValidatorErrorTypes {
  ApplicationError = 'ApplicationError',
  InstructionError = 'InstructionError'
}
